import { inputLayerGroups, LayerGroup } from "fond/layers";

/** Whether every layer in the group is present. */
export const hasLayerGroup = (layerKeys: string[], group: LayerGroup): boolean => group.layers.every(({ id }) => layerKeys.includes(id));

/** Names of the group's layers that are not present. */
export const getMissingLayerNames = (layerKeys: string[], group: LayerGroup): string[] =>
  group.layers.filter(({ id }) => !layerKeys.includes(id)).map(({ name }) => name);

/** Whether the version has leadins plus an underground or aerial network. */
export const isDataPrepComplete = (layerKeys: string[]): boolean =>
  hasLayerGroup(layerKeys, inputLayerGroups.inLeadIns) &&
  (hasLayerGroup(layerKeys, inputLayerGroups.inUnderground) || hasLayerGroup(layerKeys, inputLayerGroups.spanPole));
